export enum EnumTelaContaBancaria{
    CONTA = 1,
    PARAMETRIZACAO = 2
}